export class Convention {
  public Ident: string;
  public Name: string;
  public IsChecked: boolean;
  public IdRelation: string;
  public Montant: number;
}
